var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.234 3H23L22.766 5H12L12.234 3Z",
    fill: "#F2962E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.734 11H22.5L22.266 13H11.5L11.734 11Z",
    fill: "#F2962E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.234 18.5H22L21.766 20.5H11L11.234 18.5Z",
    fill: "#F2962E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18715 1.00015H4.27965C4.01374 1.005 3.75882 1.10707 3.56306 1.28709C3.36729 1.4671 3.24424 1.71258 3.21715 1.97715L2.87465 5.88615C2.86099 6.01058 2.874 6.13649 2.91281 6.2555C2.95163 6.3745 3.01536 6.48387 3.09976 6.57631C3.18416 6.66876 3.2873 6.74216 3.40229 6.79161C3.51728 6.84107 3.64149 6.86546 3.76665 6.86315H7.67565C7.94155 6.8583 8.19647 6.75622 8.39224 6.57621C8.58801 6.3962 8.71106 6.15072 8.73815 5.88615L9.07965 1.97715C9.09323 1.85269 9.08015 1.72677 9.04127 1.60776C9.0024 1.48876 8.93862 1.3794 8.85418 1.28697C8.76974 1.19453 8.66658 1.12115 8.55156 1.07169C8.43655 1.02224 8.31232 0.997848 8.18715 1.00015Z",
    fill: "#F2962E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8192 16.6371H2.9102C2.6443 16.642 2.38938 16.744 2.19361 16.924C1.99785 17.1041 1.87479 17.3495 1.8477 17.6141L1.5052 21.5231C1.49163 21.6475 1.50469 21.7734 1.54354 21.8924C1.58239 22.0113 1.64613 22.1207 1.73051 22.2131C1.81489 22.3055 1.91799 22.3789 2.03295 22.4284C2.1479 22.4779 2.27207 22.5023 2.3972 22.5001H6.3062C6.57211 22.4953 6.82703 22.3932 7.0228 22.2132C7.21856 22.0332 7.34162 21.7877 7.3687 21.5231L7.7112 17.6141C7.72478 17.4897 7.71171 17.3638 7.67287 17.2448C7.63402 17.1259 7.57028 17.0165 7.4859 16.9241C7.40151 16.8317 7.29842 16.7583 7.18346 16.7088C7.06851 16.6593 6.94434 16.6349 6.8192 16.6371Z",
    fill: "#F2962E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26525 12.3231L7.75025 8.99988L9.00025 10.4999L4.25024 14.9999L1.61304 12.4999L3.00021 10.9999L4.26525 12.3231Z",
    fill: "#F2962E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.f78c06fa726a303b98dc2a22ed38f3c8.svg";
export { ForwardRef as ReactComponent };